<template>
  <div >
        <div class="row mt-2">
            <div class="col-lg-11 col-11 mx-auto">
                <div class="card card-widget widget-user">
                <div class="widget-user-header text-white"
                                style="background: url('/assets/images/pexels-pixabay-Snow-Mountain2000fshead.png')  center;">
                                <h3 class="widget-user-username text-left">Choose Better.</h3>
                                <h2 class="widget-user-desc text-right">Design Version 2.0 of You.</h2>
                                <h3 class="widget-user-username text-right">For the Future Self that <u><em>you</em></u> want.</h3>
                            </div>
                            <div class="widget-user-image">
                                <img class="img-circle" src="/assets/images/artist128x128.png" alt="User Avatar">
                            </div>
                </div>
            </div>
        </div>

<div class="habit-card-sub-body d-flex mx-auto" >
        <div class="card-body">
            <div class="col-12 text-center">
         <!-- class="img-circle" -->
          <h2 >My FutureSelf Dashboard</h2>
<!-- <img width="350px;" src="/graphs/UpOrDownDisabilityGraph2.png" alt="User Avatar"> -->
        <h6 class="text-primary" ><a href="">(Don't forget your Morning Routine!)</a></h6>
            </div>
            <div class="row">

                <div class="color-palette-set bordered m-2 p-4">
                   <h5 class=" px-1">Designing My Future</h5>
                  <button class="btn bg-primary color-palette px-1" @click="showVideo">The Why and How&nbsp;<i class="fas fa-video fai-blue"></i></button>
                </div>
                <div class="color-palette-set  bordered  m-2 p-4">
                  <h5 class=" px-1">Design/Review my Future-Self Strategy</h5>
                        <button class="btn bg-warning color-palette px-1" @click="defineMyFS">Design/Review my Future-Self Strategy &amp; Plan &nbsp;<i class="fas fa-pen fai-green"></i>
                        </button>
                    </div>
                </div>
                <div v-if="myfsdata && myfsdata.length>0" class="color-palette-set  bordered  m-2 p-4">
                  <div class="bg-info color-palette px-1"><span>Report today's Performance</span> <i class="far fa-calendar-alt"></i></div>
                  <div class="bg-info disabled color-palette px-1"><span><button class="btn btn-sm fai-blue bg-light mb-2" @click="reportMyPerformance">Track/Report my Performance&nbsp;<i class="fa fa-pen fai-orange"></i></button></span></div>
                </div>
                <div  v-if="myfsdata && myfsdata.length>0" class="color-palette-set  bordered  m-2 p-4">
                  <div class="bg-success color-palette px-1"><span>View my Performance Results</span> <i class="fas fa-retweet"></i></div>
                  <div class="bg-success disabled color-palette px-1"><span><button class="btn btn-sm fai-blue bg-light mb-2" @click="viewMyPerformance">View my Performance Results&nbsp;<i class="fas fa-chart-area fai-blue"></i></button></span></div>
                </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>

import axios from 'axios';
import Errors from '../partials/Errors.vue';
import Swal from 'sweetalert2';
var _ = require('lodash');
import EventBus from '../../event-bus';
import { v4 as uuidv4 } from 'uuid';

export default {
    components: { Errors },
    name: "MyFSDashboard",
    data() {
        return {
            userdata:[],
           myfsdata:[],
            errors: {
                        nahme: '',
                        message: '',
                    },
            showVideoName:'designing_your_futureself_why_how',
            videoData:'',
            videoText:'',
            video:[],
            thisComponentName:'',
        }
    },
    props: {
        user:'',
        myfsdetails:'',
        videolinks:''
    },
    mounted() {
        this.thisComponentName = this.$options.name;
        this.userdata = JSON.parse(this.user);
        this.myfsdata = JSON.parse(this.myfsdetails);
        this.videoData = JSON.parse(this.videolinks);
    },

    methods: {
        defineMyFS(){
            window.location.replace('/fself/create');
        },
        showVideo(){
            console.error('MyFSDashboard.....');
            // var videourl = this.extractVideoURL(this.showVideoName);
            this.setupVideo();
            console.log('videourl extracted: ' + this.video[0].url);
            const payload = {title:'The Importance of (Your) FutureSelf', videourl:  this.video[0].url,
              displayText: this.video[0].title               };//'https://player.vimeo.com/video/626019659?h=fb5c62f51f'};
            EventBus.$emit('displayVideoModal', payload);
        },
        reportMyPerformance(){
            window.location.replace('/fself/view');
        },
        viewMyPerformance(){
            window.location.replace('/fself/reports');
        },
        // extractVideoURL(videokey) {
        //     var videoURL = '';
        //    for (const [key, value] of Object.entries(this.videoData)) {
        //         if(key == videokey) {
        //             videoURL= value;
        //         }
        //     }
        //     return videoURL;
        // },
        // showVideoModal(index){
        //     const payload = {title:"Why a Time-Slice, when we can post on 100's of other Social Media sites?",
        //     videourl: this.videoSrc[index],
        //     displayText: this.videoText};
        //     EventBus.$emit('displayVideoModal', payload);
        // },
        setupVideo() {
            var videoNum = 0;
            const siteVideoName = this.thisComponentName + "_video";
            console.log(`Looking for ${siteVideoName}`);
            this.videoData.forEach(video => {
                const videoName = video.name;
                const vidUrl = video.url;
                const vidDuration = video.duration;
                console.log(`${videoName}, ${vidUrl}, ${vidDuration}`);
                    if(videoName == siteVideoName) {
                        console.log(`Found it: ${videoName}, ${vidUrl}, ${vidDuration}`);
                        this.video[videoNum] = video;
                        // this.videoSrc[videoNum] = vidUrl;
                        // this.videoDuration[videoNum] = vidDuration;
                        // this.videoTitle[videoNum] = video.title;
                        videoNum++;
                    }
            });
        },

    }


}
</script>

<style scoped>
.habit-page {
  -ms-flex-align: center;
  align-items: center;
  background: #e9ecef;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  height: 100vh;
  -ms-flex-pack: center;
  justify-content: center;
}
.habit-box {
  width: 540px;

}

.habit-card-body {
  background: #eee;
  border-top: 0;
  color: #666;
  padding: 20px;
}
.habit-card-sub-body {
    width:80%;
    border:1.5px solid #fff;
    background: rgb(230, 234, 247);
    border-top: 1em;
    margin: 4.4em;
    color: #666;
    padding: 20px;
    border-radius:4px;/*2em 2em 0em 0em;*/
    box-shadow: #ddd 4px 4px 4px;
}
.input-group{
margin-bottom:.4em;
}

.btn-container{
display:flex;
margin:1em;
}
a, button {
margin-left:auto;
}
.div-box{
margin: 2em;
padding: 2em;
border: solid 1px #fff;
box-shadow: 4px 4px 4px #666;
 border-radius:2em 2em 0em 0em;
}
.customElements{
margin: 2em;
padding: 2em;
border: solid  1px #fff;
border-radius:2em 2em 0em 0em;
box-shadow: 4px 4px 4px #666;
}
.header-box-msg, .habit-table-head{
padding:.75em;
background:#343a40;
color:#ffc107;
}
.tracker-btn{
    margin-top: .5em;
    margin-bottom: .5em;
    margin-left:1em;
    /* margin-right:1em; */
    width:80%;
    padding: .5em;
    /* align-content: center; */
}
.fai-red{
    color:rgb(129, 67, 67);
}
.fai-green{
    color:rgb(65, 131, 65);
}
.fai-blue{
    color:rgb(18, 7, 240);
}
.fai-orange{
    color:rgb(230, 111, 13);
}





.mobile-first,
.desktop-first {
  padding: 1em;
  box-shadow: 0 0 1rem rgba(0, 0, 0, 0.15);
  margin: 2em auto;
  max-width: 750px;
}

/*  mobile-first */
@media (min-width: 600px) {
  .mobile-first .sales-points {
    display: flex;
    justify-content: space-between;
  }

  .mobile-first .sales-point {
    width: 30%;
  }
}

/* desktop first */
.desktop-first .sales-points {
  display: flex;
  justify-content: space-between;
}

.desktop-first .sales-point {
  width: 30%;
}

@media (max-width: 600px) {
  .desktop-first .sales-points {
    display: block;
  }

  .desktop-first .sales-point {
    width: 100%;
  }
}
.bordered{
border: .5px solid rgb(193, 191, 191);
border-radius: 4px;
padding: 82px;
margin: 2px;
background: #d9e7f4;
}





</style>
